import "../../Stylesheet/Experience.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { useContext } from "react";
import { LanguageContext } from "../../Context/LanguageContext";

export default function Experience() {

  const { t,lang } = useContext(LanguageContext);
  const e = t.experience;

  return (
    <section className="experience">

      {/* Header */}
      <div className="experience-header">
        <h1 className={lang === "ta" ? "h2-t" : "h2-e"}>{e.title}</h1>
        <p>{e.subtitle}</p>
      </div>

      {/* Timeline */}

      <div className="timeline">
        {e.items.map((item, index) => (
          <div className="timeline-row" key={index}>

            <div className="left">
              <h3>{item.role}</h3>
              <span>{item.company}</span>
            </div>

            <div className="center">
              <div className="dot"></div>
            </div>

            <div className="right">
              <div className="date">
                <FaRegCalendarAlt />
                <span>{item.date}</span>
              </div>
              <p>{item.description}</p>
            </div>

          </div>
        ))}
      </div>

    </section>
  );
}
